import { assertNotEmpty } from '@festina-life/core'
import cx from 'classnames'

import type { SubTemplateFieldValue } from '../../types/templateModel'
import { subTemplatedFieldValueDocumentation } from '../templateFieldDocumentation/helpers'

type Props = {
  variant: SubTemplateFieldValue
  isCentered?: boolean
  isExpanded?: boolean
}

export const SubTemplatedFieldValueType = ({
  variant,
  isCentered = true,
}: Props) => {
  const documentation = subTemplatedFieldValueDocumentation(variant)
  assertNotEmpty(documentation)

  const { modelFieldType } = documentation

  return (
    <div className={cx('flex flex-col', { 'items-center': isCentered })}>
      <div>{modelFieldType}</div>
    </div>
  )
}
